module.exports = __webpack_public_path__ + "static/media/training_somatic_movement.9e1507ba.webp";